import React, { useEffect, useState } from 'react';
import { Form, Button, Row, Col, Card, Image } from 'react-bootstrap';

import PaperClipIcon from '../../../assets/images/icons/Paperclip.svg';
import Cross from '../../../assets/images/icons/cross.svg';
import delivaApiService from '../../../common/services/apiService';
import {
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom/cjs/react-router-dom.min';
import {
  showErrorToast,
  showSuccessToast,
} from '../../../common/helpers/Utils';
import Header from '../commonAdmin/Header';
import Sidebar from '../commonAdmin/Sidebar';
import Loader from '../../common/Loader';
import Footer from '../commonAdmin/Footer';

import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from 'use-places-autocomplete'; // Ensure this is also present

const CreateReferral = (props) => {
  const {
    ready,
    value = formData.region || 'Nigeria',
    setValue,
    suggestions: { status, data },
    clearSuggestions,
  } = usePlacesAutocomplete({
    debounce: 300,
  });

  console.log('location data', data);

  //
  const { state } = useLocation();
  const { id, tab, isCopied } = state;
  const initialFormData = {
    roleId: '',
    referralCondition: [], // Initialize as an empty array
    referralCount: '',
    deliveryRequestType: 'LOCAL_DELIVERY',
    offerName: '',
    discountType: '',
    discountAmount: '',
    percentageDiscount: '100',
    maxDiscountAmount: '',
    region: 'Nigeria',
    currency: 'Naira (₦)',
    description: '',
    code: '',
    imageUrl: 'www',
    discountApplicationType: 'AUTOMATIC_APPLICATION',
    offerType: '',

    // promo fields
    discountApplication: '',
    usageFrequency: '',
    targetAudience: [],
    minimumOrderAmount: '',
    usageLimits: '',
    countOfUsageLimits: '',
    promotionStartDate: '',
    promotionStartTime: '',
    promotionEndDate: '',
    promotionEndTime: '',
    geolocationBasedPromotions: '',
    occasions: '',
    otherOccasions: '',
    recurringPromotions: '',
  };

  const [editData, setEditData] = useState(null); // Initialize with null
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [userType, selectUserType] = useState([]); // Initialize as empty array
  const [selectDiscountType, setSelectDiscountType] = useState([]); // Initialize as empty array
  const [selectDelieryType, setSelectDelieryType] = useState([]); // Initialize as empty array
  const [isLoading, setIsLoading] = useState(false);
  const [referralCondition, setReferralCondition] = useState([]);

  const [showLoader, setShowLoader] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      let updatedFormData = {
        ...prev,
        [name]: value,
      };

      if (name === 'roleId' && tab === 'referral') {
        updatedFormData.discountType =
          value === '2' ? 'FREE_DELIVERY' : value === '3' ? 'CASH_AMOUNT' : '';
        updatedFormData.discountAmount = value === '2' ? '100' : '';
      }

      if (
        !updatedFormData.deliveryRequestType &&
        selectDelieryType?.length > 0
      ) {
        updatedFormData.deliveryRequestType = selectDelieryType[0].value;
      }
      console.log('updated data form', updatedFormData);
      return updatedFormData;
    });

    console.log('form change detected:', name, value);

    setErrors((prevError) => {
      let errorFormData = {
        ...prevError,
        [name]: null,
      };
      if (name === 'roleId' && tab === 'referral') {
        if (value === '2') {
          errorFormData.discountType = null;
          errorFormData.discountAmount = null;
        }
        if (value === '3') {
          errorFormData.discountType = null;
          errorFormData.maxDiscountAmount = null;
        }
      }
      return errorFormData;
    });
  };

  const validate = (formData) => {
    console.log('inside validater', formData);
    const errors = {};
    if (!formData.roleId) errors.roleId = 'User type is required';
    // if (!formData.offerType) errors.offerType = 'Offer type is required';
    if (!formData.deliveryRequestType)
      errors.deliveryRequestType = 'Delivery request type is required';
    if (!formData.referralCondition || formData.referralCondition.length === 0)
      errors.referralCondition = 'Referral condition is required';
    if (!formData.discountType)
      errors.discountType = 'Discount type is required';
    // max discount
    console.log(
      'inside validater formData.roleId',
      formData.roleId,
      typeof formData.roleId
    );

    if (parseInt(formData.roleId) !== 3) {
      if (formData.maxDiscountAmount === '') {
        errors.maxDiscountAmount = 'Max Discount Amount is required';
      } else if (isNaN(formData.maxDiscountAmount)) {
        errors.maxDiscountAmount = 'Max Discount Amount must be a number';
      } else if (parseFloat(formData.maxDiscountAmount) <= 0) {
        errors.maxDiscountAmount = 'Max Discount Amount must be greater than 0';
      } else if (parseFloat(formData.maxDiscountAmount) > 99999) {
        errors.maxDiscountAmount = 'Max Discount Amount cannot exceed 99999';
      }
    }
    // Offer name
    if (!formData.offerName) {
      errors.offerName = 'Offer name is required';
    } else if (formData.offerName.length < 3) {
      errors.offerName = 'Offer name must be at least 3 characters long';
    } else if (/^\d+$/.test(formData.offerName)) {
      errors.offerName = 'Offer name cannot be numbers only';
    }
    // discount amount
    if (
      formData.discountType !== 'FREE_DELIVERY' &&
      (!formData.discountAmount || parseFloat(formData.discountAmount) <= 0)
    ) {
      errors.discountAmount = 'Discount amount is required.';
    } else if (
      formData.discountType !== 'FREE_DELIVERY' &&
      isNaN(formData.discountAmount)
    ) {
      errors.discountAmount = 'Discount amount must be a number';
    } else if (
      formData.discountType !== 'FREE_DELIVERY' &&
      parseFloat(formData.discountAmount) > 99999
    ) {
      errors.discountAmount = 'Discount amount cannot exceed 99999';
    }

    // refferl count
    if (!formData.referralCount) {
      errors.referralCount = 'Referral count is required';
    } else if (!/^\d+$/.test(formData.referralCount)) {
      errors.referralCount = 'Referral count must be a valid number';
    } else if (parseInt(formData.referralCount) <= 0) {
      errors.referralCount = 'Referral count must be greater than 0';
    } else if (parseInt(formData.referralCount) > 99999) {
      errors.referralCount = 'Referral count cannot exceed 99999';
    }
    // description
    if (!formData.description) errors.description = 'Description is required';
    // code
    if (!formData.code) {
      errors.code = 'Code is required';
    } else if (/\s/.test(formData.code)) {
      errors.code = 'Code cannot contain spaces';
    } else if (!/^[a-zA-Z0-9-_]+$/.test(formData.code)) {
      errors.code =
        'Code must contain only letters, numbers, hyphens (-), or underscores (_)';
    } else if (/^\d+$/.test(formData.code)) {
      errors.code = 'Code cannot be only numbers';
    } else if (formData.code.length < 5) {
      errors.code = 'Code must be at least 5 characters';
    } else if (formData.code.length > 15) {
      errors.code = 'Code must be at most 15 characters';
    }

    // promo validation fields
    if (formData.offerType === 'PROMOTION') {
      if (
        !formData.discountApplication ||
        formData.discountApplication.length === 0
      ) {
        errors.discountApplication = 'Discount Application is required';
      }
      if (!formData.promotionStartDate) {
        errors.promotionStartDate = 'Promotion Start Date is required';
      }
      if (!formData.promotionEndDate) {
        errors.promotionEndDate = 'Promotion End Date is required';
      }
    }
    console.log('Errors data', errors);

    return errors;
  };

  const getEditDiscount = (referralId) => {
    setIsLoading(true); // Start loading when fetching edit data
    let payload = {
      referralId: referralId,
    };
    // console.log('line no 177 payload', payload)
    delivaApiService('getReferral', payload)
      .then((response) => {
        if (response?.data?.status === 400) {
          showErrorToast(response?.data?.message);
        } else if (response?.data?.status === 200) {
          setEditData(response?.data?.resourceData);
        } else {
          // Handle other statuses if necessary
        }
      })
      .catch((error) => {
        console.error('Failed to get referral:', error);
        showErrorToast('Failed to fetch referral data.');
      })
      .finally(() => {
        setIsLoading(false); // Stop loading
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    console.log('Form submitted:', formData);
    let addPayload = {
      ...formData,
      code: formData.code.toUpperCase().trim(),
    };
    setIsLoading(true); // Start loading

    // Conditionally call addReferral or editReferral based on `id`
    if (id && !isCopied) {
      // If `id` exists, it's an edit scenario
      const editPayload = {
        ...formData,
        referralId: id, // Ensure referralId is included for edit
      };
      delivaApiService('addReferral', editPayload)
        .then((response) => {
          if (response?.data?.status === 400) {
            showErrorToast(response?.data?.message);
          } else if (response?.data?.status === 200) {
            showSuccessToast('Referral Updated Successfully');
            localStorage.setItem('isEdited', 'true');
            history.push({
              pathname: `/promotionReferralList`,
              state: {
                tab: 'referral',
                fromEdit: true,
              },
            });
          } else {
            // Handle other statuses if necessary
          }
        })
        .catch((error) => {
          console.error('Failed to update referral:', error);
          showErrorToast('Failed to update referral.');
        })
        .finally(() => {
          setIsLoading(false); // Stop loading
        });
    } else {
      // No `id`, it's an add scenario
      delivaApiService('addReferral', addPayload)
        .then((response) => {
          if (response?.data?.status === 400) {
            showErrorToast(response?.data?.message);
          } else if (response?.data?.status === 200) {
            !isCopied && showSuccessToast('New Referral Added Successfully');
            isCopied && showSuccessToast('Referral Copied Successfully');
            localStorage.setItem('isEdited', 'true');
            history.push({
              pathname: `/promotionReferralList`,
              state: {
                tab: 'referral',
                fromEdit: true,
              },
            });
            setFormData(initialFormData);
          } else {
            // Handle other statuses if necessary
          }
        })
        .catch((error) => {
          console.error('Failed to add referral:', error);
          showErrorToast('Failed to add referral.');
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    setErrors({});
  };

  const fetchInitialData = async () => {
    try {
      setShowLoader(true);

      const [rolesRes, deliveryTypesRes, discountTypesRes] = await Promise.all([
        delivaApiService('getAllRole'),
        delivaApiService('getAllDeliveryRequestType'),
        delivaApiService('getAllDiscountType'),
      ]);

      if (rolesRes?.status === 200) {
        selectUserType(rolesRes.data?.resourceData);
        console.log('getAllRole', rolesRes.data?.resourceData);
      }

      if (deliveryTypesRes?.status === 200) {
        setSelectDelieryType(deliveryTypesRes.data?.resourceData);
        console.log(
          'getAllDeliveryRequestType',
          deliveryTypesRes.data?.resourceData
        );
      }

      if (discountTypesRes?.status === 200) {
        setSelectDiscountType(discountTypesRes.data?.resourceData);
        console.log('getAllDiscountType', discountTypesRes.data?.resourceData);
      }
    } catch (error) {
      console.error('Error fetching initial data:', error);
      showErrorToast('Failed to fetch initial form data.');
    } finally {
      setShowLoader(false);
    }
  };

  const handleReferralConditionChange = (value) => {
    setReferralCondition((prev) => {
      const lower = value.toLowerCase();
      const exists = prev.some((item) => item.toLowerCase() === lower);
      const updated = exists
        ? prev.filter((item) => item.toLowerCase() !== lower)
        : [...prev, value];

      setFormData((prevData) => ({
        ...prevData,
        referralCondition: updated,
      }));

      // console.log("give me updated", updated);

      setErrors((prevError) => ({
        ...prevError,
        referralCondition: null,
      }));

      return updated;
    });
  };

  // Handle application type selection for Promotions
  // const handleApplicationType = (value) => {
  //   setApplicationType((prev) => {
  //     const updated = prev.includes(value)
  //       ? prev.filter((v) => v !== value)
  //       : [...prev, value];

  //     // Now update formData with the new value
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       applicationType: updated,
  //     }));
  //     console.log('give me updated', updated)
  //     setErrors((prevError) => {
  //       return { ...prevError, applicationType: null }
  //     });
  //     return updated;
  //   });
  // };

  const history = useHistory();

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (id) {
      getEditDiscount(id);
    }
  }, [id]);

  useEffect(() => {
    if (editData) {
      console.log('editData...', editData);
      if (editData.offerType !== 'PROMOTION') {
        setFormData((prevFormData) => ({
          ...prevFormData,
          roleId:
            (editData.userType === 'customer' && 2) ||
            (editData.userType === 'delivery_agent' && 3), // Handle potentially missing data
          referralCondition: editData.referralCondition || [],
          referralCount: editData.referralCount || '',
          deliveryRequestType:
            selectDelieryType?.find(
              (o) => o.label === editData.deliveryRequestType
            )?.value || '',
          offerName: editData.offerName || '',
          discountType:
            selectDiscountType?.find((o) => o.label === editData.discountType)
              ?.value || '',
          discountAmount: editData.discountAmount || '',
          percentageDiscount: editData.percentageDiscount || '',
          maxDiscountAmount: editData.maxDiscountAmount || '',
          description: editData.description || '',
          code: editData.code.toUpperCase().trim() || '',
          offerType: editData.offerType
            ? editData.offerType.toUpperCase().trim()
            : '', // Normalize the value
          region: editData.region || 'Nigeria',
          currency: editData.currency || 'Naira (₦)',
          imageUrl: editData.imageUrl || 'www',
        }));
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          roleId:
            (editData.userType === 'customer' && 2) ||
            (editData.userType === 'delivery_agent' && 3), // Handle potentially missing data
          referralCondition: editData.referralCondition || [],
          referralCount: editData.referralCount || '',
          deliveryRequestType:
            selectDelieryType?.find(
              (o) => o.label === editData.deliveryRequestType
            )?.value || '',
          offerName: editData.offerName || '',
          discountType:
            selectDiscountType?.find((o) => o.label === editData.discountType)
              ?.value || '',
          discountAmount: editData.discountAmount || '',
          percentageDiscount: editData.percentageDiscount || '',
          maxDiscountAmount: editData.maxDiscountAmount || '',
          description: editData.description || '',
          code: editData.code.toUpperCase().trim() || '',
          offerType: editData.offerType
            ? editData.offerType.toUpperCase().trim()
            : '', // Normalize the value
          region: editData.region || 'Nigeria',
          currency: editData.currency || 'Naira (₦)',
          imageUrl: editData.imageUrl || 'www',
          // promo fields
          discountApplication: '',
          usageFrequency: '',
          targetAudience: [],
          minimumOrderAmount: '',
          usageLimits: '',
          countOfUsageLimits: '',
          promotionStartDate: '',
          promotionStartTime: '',
          promotionEndDate: '',
          promotionEndTime: '',
          geolocationBasedPromotions: '',
          occasions: '',
          otherOccasions: '',
          recurringPromotions: '',
        }));
      }

      // Also update the referralCondition state for checkboxes
      setReferralCondition(editData.referralCondition || []);
    }
  }, [editData, selectDelieryType, selectDiscountType]);

  return (
    <div className="page__wrapper h-100">
      <Header {...props} />
      <div className="mainContainer CustomerTable">
        <Row noGutters className="h-100">
          <Sidebar {...props} />
          <Col md={9} lg={10} className="boxTyp3">
            <div className="container-fluid">
              <div className="content-wrapper">
                <h3 className="font-weight-normal mb-0 line-ht color-33 fs-24">
                  {id && !isCopied ? 'Edit' : isCopied ? 'Copy' : 'Add'}{' '}
                  Referral
                </h3>
                <h5 className="font-weight-normal mb-0 line-ht color-head">
                  <span
                    className="pointer"
                    onClick={() =>
                      history.push({
                        pathname: `/promotionReferralList`,
                        state: {
                          tab: tab,
                        },
                      })
                    }
                  >
                    Promotion & Referral
                  </span>
                  <span className="icon-next mx-2 fs12"></span>
                  <span className="pointer">
                    {id && !isCopied ? 'Edit' : isCopied ? 'Copy' : 'Add'}{' '}
                    Referral
                  </span>
                </h5>
                <Card className="custom-card mt-4">
                  <Card.Body>
                    <Form onSubmit={handleSubmit} autoComplete="off">
                      <Row>
                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Select User Type
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="roleId"
                              className="py-0"
                              value={formData.roleId} // This should now correctly reflect editData.roleId
                              onChange={handleChange}
                            >
                              <option value="">Select User Type</option>
                              <option value="2">Sender</option>
                              <option value="3">Delivery Partner</option>
                            </Form.Control>
                            {errors.roleId && (
                              <div className="text-danger">{errors.roleId}</div>
                            )}
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Select Offer Type
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="offerType"
                              className="py-0"
                              value={formData.offerType} // This should now correctly reflect editData.offerType
                              onChange={handleChange}
                              disabled
                            >
                              <option key={1} value="REFERRAL">
                                Referral
                              </option>
                            </Form.Control>
                            {errors.offerType && (
                              <div className="text-danger">
                                {errors.offerType}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      </Row>

                      {/* Referral Form Fields */}
                      <Row>
                        {!(formData.offerType === 'PROMOTION') && (
                          <Col lg={6} className="mb-4 mb-lg-0">
                            <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                              Referral Condition
                              <span className="text-danger">*</span>
                            </h3>
                            <Form.Group
                              className="d-flex mb-0"
                              style={{ gap: '30px' }}
                            >
                              <div className="checkboxContainer">
                                <input
                                  id="onboarding"
                                  type="checkbox"
                                  name="referralCondition"
                                  value="ONBOARDING"
                                  checked={
                                    referralCondition.includes('ONBOARDING') ||
                                    referralCondition.includes('Onboarding')
                                  }
                                  onChange={() =>
                                    handleReferralConditionChange('ONBOARDING')
                                  }
                                />
                                <label htmlFor="onboarding">Onboarding</label>
                              </div>
                              <div className="checkboxContainer">
                                <input
                                  id="delivery"
                                  type="checkbox"
                                  name="referralCondition"
                                  value="DELIVERY"
                                  checked={
                                    referralCondition.includes('DELIVERY') ||
                                    referralCondition.includes('Delivery')
                                  }
                                  onChange={() =>
                                    handleReferralConditionChange('DELIVERY')
                                  }
                                />
                                <label htmlFor="delivery">Delivery</label>
                              </div>
                            </Form.Group>
                            {errors.referralCondition && (
                              <div className="text-danger">
                                {errors.referralCondition}
                              </div>
                            )}
                          </Col>
                        )}
                        {!(formData.offerType === 'PROMOTION') && (
                          <Col lg={6}>
                            <Form.Group className="custom-form">
                              <Form.Label className="color-head">
                                Referral Count
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="referralCount"
                                value={formData.referralCount}
                                onChange={handleChange}
                                className="py-0"
                                inputMode="numeric"
                                maxLength="5"
                                onKeyDown={(e) => {
                                  const allowedKeys = [
                                    'Backspace',
                                    'Tab',
                                    'ArrowLeft',
                                    'ArrowRight',
                                    'Delete',
                                  ];
                                  if (
                                    !/^\d$/.test(e.key) &&
                                    !allowedKeys.includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors.referralCount && (
                                <div className="text-danger">
                                  {errors.referralCount}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        )}

                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Delivery Request Type
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="deliveryRequestType"
                              className="py-0"
                              value={formData.deliveryRequestType}
                              onChange={handleChange}
                              disabled
                            >
                              {selectDelieryType &&
                              selectDelieryType.length > 0 ? (
                                selectDelieryType
                                  .slice(0, 1)
                                  .map((deliveryType, index) => (
                                    <option
                                      key={index}
                                      value={deliveryType.value}
                                    >
                                      {deliveryType.label}
                                    </option>
                                  ))
                              ) : (
                                <option disabled>
                                  No delivery types available
                                </option>
                              )}
                            </Form.Control>

                            {errors.deliveryRequestType && (
                              <div className="text-danger">
                                {errors.deliveryRequestType}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Name Of Offer
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="offerName"
                              value={formData.offerName}
                              onChange={handleChange}
                              className="py-0"
                            />
                            {errors.offerName && (
                              <div className="text-danger">
                                {errors.offerName}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Discount Type
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="discountType"
                              className="py-0"
                              value={formData.discountType}
                              onChange={handleChange}
                              disabled
                            >
                              {(tab !== 'referral' ||
                                !formData.discountType) && (
                                <option value="">Select Discount Type</option>
                              )}

                              {selectDiscountType &&
                              selectDiscountType.length > 0 ? (
                                selectDiscountType
                                  .filter((discountType) => {
                                    if (
                                      tab === 'referral' &&
                                      formData.roleId === '2'
                                    ) {
                                      return (
                                        discountType.value === 'FREE_DELIVERY'
                                      );
                                    } else if (
                                      tab === 'referral' &&
                                      formData.roleId === '3'
                                    ) {
                                      return (
                                        discountType.value === 'CASH_AMOUNT'
                                      );
                                    }
                                    return true;
                                  })
                                  .map((discountType, index) => (
                                    <option
                                      key={index}
                                      value={discountType.value}
                                    >
                                      {discountType.label}
                                    </option>
                                  ))
                              ) : (
                                <option disabled>
                                  No discount types available
                                </option>
                              )}
                            </Form.Control>
                            {errors.discountType && (
                              <div className="text-danger">
                                {errors.discountType}
                              </div>
                            )}
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              {formData.discountType === 'FREE_DELIVERY'
                                ? 'Discount Percentage(%)'
                                : 'Reward Amount(₦)'}{' '}
                              <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="discountAmount"
                              disabled={
                                formData.discountType === 'FREE_DELIVERY'
                              }
                              value={
                                formData.discountType === 'FREE_DELIVERY'
                                  ? formData.percentageDiscount
                                  : formData.discountAmount
                              }
                              onChange={handleChange}
                              className="py-0"
                              inputMode="numeric"
                              maxLength="5"
                              onKeyDown={(e) => {
                                const allowedKeys = [
                                  'Backspace',
                                  'Tab',
                                  'ArrowLeft',
                                  'ArrowRight',
                                  'Delete',
                                ];
                                if (
                                  !/^\d$/.test(e.key) &&
                                  !allowedKeys.includes(e.key)
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            {errors.discountAmount && (
                              <div className="text-danger">
                                {errors.discountAmount}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                        {!(parseInt(formData.roleId) === 3) && (
                          <Col lg={6}>
                            <Form.Group className="custom-form">
                              <Form.Label className="color-head">
                                Max. Amount of Discount(Upto)
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="maxDiscountAmount"
                                value={formData.maxDiscountAmount}
                                onChange={handleChange}
                                className="py-0"
                                inputMode="numeric"
                                maxLength="5"
                                onKeyDown={(e) => {
                                  const allowedKeys = [
                                    'Backspace',
                                    'Tab',
                                    'ArrowLeft',
                                    'ArrowRight',
                                    'Delete',
                                  ];
                                  if (
                                    !/^\d$/.test(e.key) &&
                                    !allowedKeys.includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                              />
                              {errors.maxDiscountAmount && (
                                <div className="text-danger">
                                  {errors.maxDiscountAmount}
                                </div>
                              )}
                            </Form.Group>
                          </Col>
                        )}

                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Country
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="region"
                              className="py-0"
                              value={formData.region}
                              onChange={handleChange}
                              disabled
                            >
                              <option value="Nigeria">Nigeria</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>

                        <Col lg={6}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Currency
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="currency"
                              className="py-0"
                              value={formData.currency}
                              onChange={handleChange}
                              disabled
                            >
                              <option value="Naira (₦)">Naira (₦)</option>
                            </Form.Control>
                          </Form.Group>
                        </Col>

                        <Col lg={12}>
                          <Form.Group className="custom-form">
                            <Form.Label className="color-head">
                              Description<span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              as="textarea"
                              rows="3"
                              name="description"
                              value={formData.description}
                              onChange={handleChange}
                              maxLength="100"
                              className="py-0"
                            />
                            {errors.description && (
                              <div className="text-danger">
                                {errors.description}
                              </div>
                            )}
                            <span className="min-char d-block">
                              Max 100 chars
                            </span>
                          </Form.Group>
                        </Col>

                        {!(formData.offerType === 'PROMOTION') && (
                          <Col lg={6}>
                            <Form.Group className="custom-form">
                              <Form.Label className="color-head">
                                Code<span className="text-danger">*</span>
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="code"
                                value={formData.code}
                                onChange={handleChange}
                                className="py-0 text-uppercase"
                              />

                              {errors.code && (
                                <div className="text-danger">{errors.code}</div>
                              )}
                            </Form.Group>
                          </Col>
                        )}

                        {!(formData.offerType === 'PROMOTION') && (
                          <Col lg={12}>
                            <Form.Group className="custom-form">
                              <Form.Label className="color-head mb-2">
                                Discount Application
                              </Form.Label>
                              <h3 className="font-weight-normal mb-4 line-ht color-33 fs20">
                                Automatic Application
                              </h3>
                            </Form.Group>
                          </Col>
                        )}
                      </Row>

                      {/* Promotion Form Fields */}
                      {formData.offerType === 'PROMOTION' && (
                        <div className="promotion-fields">
                          <section
                            className="mb-4"
                            aria-label="Discount Restrictions"
                          >
                            <Row>
                              <Col lg={12} className="mb-4">
                                <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                                  Discount Application
                                  <span className="text-danger">*</span>
                                </h3>
                                <Form.Group
                                  className="d-flex mb-0"
                                  style={{ gap: '30px' }}
                                >
                                  <div className="checkboxContainer">
                                    <input
                                      id="atmApp"
                                      type="radio"
                                      name="discountApplication"
                                      value="AUTOMATIC_APPLICATION"
                                      // checked={discountApplication.includes("AUTOMATIC_APPLICATION") || discountApplication.includes("Automatic Application")}
                                      // onChange={() => handleReferralConditionChange("AUTOMATIC_APPLICATION")}
                                    />
                                    <label htmlFor="atmApp">
                                      {' '}
                                      Automatic Application
                                    </label>
                                  </div>
                                  <div className="checkboxContainer">
                                    <input
                                      id="manual"
                                      type="radio"
                                      name="discountApplication"
                                      value="MANUAL_ENTRY"
                                      // checked={discountApplication.includes("MANUAL_ENTRY") || discountApplication.includes("Manual Entry")}
                                      // onChange={() => handleReferralConditionChange("MANUAL_ENTRY")}
                                    />
                                    <label htmlFor="manual">
                                      {' '}
                                      Manual Entry
                                    </label>
                                  </div>
                                  <div className="pl-2  ml-2 border-left"></div>
                                  <div className="checkboxContainer">
                                    <input
                                      id="stack"
                                      type="checkbox"
                                      name="discountApplication"
                                      value="STACKABLE_DISCOUNTS"
                                      // checked={referralCondition.includes("STACKABLE_DISCOUNTS") || referralCondition.includes("Stackable Discounts")}
                                      // onChange={() => handleReferralConditionChange("STACKABLE_DISCOUNTS")}
                                    />
                                    <label htmlFor="stack">
                                      Stackable Discounts
                                    </label>
                                  </div>
                                </Form.Group>
                                {errors.discountApplication && (
                                  <div className="text-danger">
                                    {errors.discountApplication}
                                  </div>
                                )}
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Code<span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="code"
                                    value={formData.code}
                                    onChange={handleChange}
                                    className="py-0 text-uppercase"
                                  />

                                  {errors.code && (
                                    <div className="text-danger">
                                      {errors.code}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Usage Frequency
                                  </Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="usageFrequency"
                                    className="py-0"
                                    value={formData.usageFrequency} // This should now correctly reflect editData.usageFrequency
                                    onChange={handleChange}
                                  >
                                    <option value="">
                                      Select Usage Frequency
                                    </option>
                                    <option value="PER_CUSTOMER">
                                      Per sender
                                    </option>
                                    <option value="OVERALL">Overall</option>
                                  </Form.Control>
                                  {errors.usageFrequency && (
                                    <div className="text-danger">
                                      {errors.usageFrequency}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Target Audience
                                  </Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="targetAudience"
                                    className="py-0"
                                    value={formData.targetAudience} // This should now correctly reflect editData.targetAudience
                                    onChange={handleChange}
                                  >
                                    <option value="">
                                      Select Target Audience
                                    </option>
                                    <option value="OVERALL">All senders</option>
                                  </Form.Control>
                                  {errors.targetAudience && (
                                    <div className="text-danger">
                                      {errors.targetAudience}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              {/* <Col lg={12} className="mb-4">
                                <div>
                                  <div class="chip">
                                    jakob.levin@gmail.com
                                    <span class="close-btn pointer" onclick="this.parentElement.remove()">
                                      <Image src={Cross} />
                                    </span>
                                  </div>
                                </div>
                              </Col> */}
                            </Row>
                          </section>
                          <section
                            className="mb-4"
                            aria-label="Discount Restrictions"
                          >
                            <Row>
                              <Col lg={12}>
                                <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                                  Discount Restrictions
                                </h3>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Minimum Order Amount
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="minimumOrderAmount"
                                    value={formData.minimumOrderAmount}
                                    onChange={handleChange}
                                    className="py-0 text-uppercase"
                                  />

                                  {errors.minimumOrderAmount && (
                                    <div className="text-danger">
                                      {errors.minimumOrderAmount}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Usage Limits
                                  </Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="usageLimits"
                                    className="py-0"
                                    value={formData.usageLimits} // This should now correctly reflect editData.usageLimits
                                    onChange={handleChange}
                                  >
                                    <option value="">
                                      Select Usage Limits
                                    </option>
                                    <option value="OVERALL">Per sender</option>
                                  </Form.Control>
                                  {errors.usageLimits && (
                                    <div className="text-danger">
                                      {errors.usageLimits}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Count of usage limits (Per sender)
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="countOfUsageLimits"
                                    value={formData.countOfUsageLimits}
                                    onChange={handleChange}
                                    className="py-0 text-uppercase"
                                  />

                                  {errors.countOfUsageLimits && (
                                    <div className="text-danger">
                                      {errors.countOfUsageLimits}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                            </Row>
                          </section>
                          <section
                            className="mb-4"
                            aria-label="Promotion Dates and Time"
                          >
                            <Row>
                              <Col lg={12}>
                                <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                                  Promotion Dates and Time
                                </h3>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Start Date
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Control
                                    type="date"
                                    name="promotionStartDate"
                                    value={formData.promotionStartDate}
                                    onChange={handleChange}
                                    className="py-0 text-uppercase"
                                  />

                                  {errors.promotionStartDate && (
                                    <div className="text-danger">
                                      {errors.promotionStartDate}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    End Date
                                  </Form.Label>
                                  <Form.Control
                                    type="date"
                                    name="promotionEndDate"
                                    value={formData.promotionEndDate}
                                    onChange={handleChange}
                                    className="py-0 text-uppercase"
                                  />

                                  {errors.promotionEndDate && (
                                    <div className="text-danger">
                                      {errors.promotionEndDate}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Start Time
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Control
                                    type="time"
                                    name="promotionStartTime"
                                    value={formData.promotionStartTime}
                                    onChange={handleChange}
                                    className="py-0 text-uppercase"
                                  />

                                  {errors.promotionStartTime && (
                                    <div className="text-danger">
                                      {errors.promotionStartTime}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    End Time
                                  </Form.Label>
                                  <Form.Control
                                    type="time"
                                    name="promotionEndTime"
                                    value={formData.promotionEndTime}
                                    onChange={handleChange}
                                    className="py-0 text-uppercase"
                                  />

                                  {errors.promotionEndTime && (
                                    <div className="text-danger">
                                      {errors.promotionEndTime}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Recurring Promotions
                                  </Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="recurringPromotions"
                                    className="py-0"
                                    value={formData.recurringPromotions} // This should now correctly reflect editData.recurringPromotions
                                    onChange={handleChange}
                                  >
                                    <option value="">
                                      Select Recurring Promotions
                                    </option>
                                    <option value="OVERALL">
                                      Every weekend
                                    </option>
                                  </Form.Control>
                                  {errors.recurringPromotions && (
                                    <div className="text-danger">
                                      {errors.recurringPromotions}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                            </Row>
                          </section>
                          <section
                            className="mb-4"
                            aria-label="Special Conditions"
                          >
                            <Row>
                              <Col lg={12}>
                                <h3 className="font-weight-normal mb-3 line-ht color-33 fs20">
                                  Special Conditions
                                </h3>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Geolocation-Based Promotions
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="geolocationBasedPromotions"
                                    value={formData.geolocationBasedPromotions}
                                    onChange={handleChange}
                                    className="py-0"
                                    placeholder="Geo location Based Promotions"
                                  />

                                  {errors.geolocationBasedPromotions && (
                                    <div className="text-danger">
                                      {errors.geolocationBasedPromotions}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Occasions
                                  </Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="occasions"
                                    className="py-0"
                                    value={formData.occasions} // This should now correctly reflect editData.occasions
                                    onChange={handleChange}
                                  >
                                    <option value="">Select Occasions</option>
                                    <option value="OVERALL">Christmas</option>
                                  </Form.Control>
                                  {errors.occasions && (
                                    <div className="text-danger">
                                      {errors.occasions}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg={6}>
                                <Form.Group className="custom-form">
                                  <Form.Label className="color-head">
                                    Please enter other occasions name
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    name="otherOccasions"
                                    value={formData.otherOccasions}
                                    onChange={handleChange}
                                    className="py-0"
                                    placeholder="Thanks given"
                                  />

                                  {errors.otherOccasions && (
                                    <div className="text-danger">
                                      {errors.otherOccasions}
                                    </div>
                                  )}
                                </Form.Group>
                              </Col>
                              {/* <Col lg={6} className='mb-4'>
                            <Form.Group className="custom-form">
                              <Form.Label className="color-head mb-2">
                                Image Attachment
                              </Form.Label>
                              <div className='attachment'>
                                <Form.Control
                                  type="file"
                                  name="imageUrl"
                                  accept="image/*"
                                  className="py-0"
                                />
                                <Image src={PaperClipIcon} />
                                <span>Please select file from here</span>
                              </div>
                            </Form.Group>
                          </Col> */}
                            </Row>
                          </section>
                        </div>
                      )}
                      {/* Common Action */}
                      <Row>
                        <Col lg={12} className="mt-4">
                          <button
                            className="btnDefault btnOutline minw-150"
                            type="button"
                            onClick={() =>
                              history.push({
                                pathname: `/promotionReferralList`,
                                state: {
                                  tab: tab,
                                },
                              })
                            }
                          >
                            Cancel
                          </button>
                          <button
                            className="btnDefault btnPrimary minw-150 ml-3"
                            type="submit"
                          >
                            {id && !isCopied
                              ? 'Update'
                              : isCopied
                              ? 'Copy'
                              : 'Add'}
                          </button>
                        </Col>
                      </Row>
                    </Form>
                  </Card.Body>
                </Card>
              </div>
            </div>
            <Footer {...props} />
          </Col>
        </Row>
        <Loader showLoader={isLoading} />
      </div>
    </div>
  );
};

export default CreateReferral;
